import { createContext, useState } from "react";
import React from "react";
import Cookies from "js-cookie";
// create context
const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  // get token from local storage
  let token = Cookies.get("auth-token");
  // get username from local storage
  let user = Cookies.get("user-name");
  let isAuth = Cookies.get("auth-token") ? true : false;
  // let phone_verified = Cookies.get("phone_verified");
  // let ocr_verified = Cookies.get("ocr_verified");

  const [auth, setAuth] = useState({
    accessToken: token,
    full_name: user,
    isAuth: isAuth,
    // phone_verified: phone_verified,
    // ocr_verified: ocr_verified,
  });

  // pass these data to all child
  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
// export provider
export default AuthContext;
